var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgOpenMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.8329V6.39149C1.5 5.83424 1.7785 5.31385 2.24217 5.00474L8.0755 1.11585C8.63533 0.742632 9.36467 0.742632 9.9245 1.11585L15.7578 5.00474C16.2215 5.31385 16.5 5.83424 16.5 6.39149V13.8329M1.5 13.8329C1.5 14.7533 2.24619 15.4995 3.16667 15.4995H14.8333C15.7538 15.4995 16.5 14.7533 16.5 13.8329M1.5 13.8329L7.125 10.0829M16.5 13.8329L10.875 10.0829M1.5 6.33285L7.125 10.0829M16.5 6.33285L10.875 10.0829M10.875 10.0829L9.9245 10.7165C9.36467 11.0897 8.63533 11.0897 8.0755 10.7165L7.125 10.0829",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgOpenMailIcon);
export default __webpack_public_path__ + "static/media/svg-open-mail-icon.1eb1859166cadc27384dd23ff98a83f4.svg";
export { ForwardRef as ReactComponent };